<template>
    <div class="com4" :class="{'bor':bor===true}">
        我是组件4
    </div>
</template>
<script>
export default {
    name: 'comFour',
    props: {
        bor: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    .com4{
        height: 50px;
        background: black;
        color: #fff;
    }
    .bor{
        border: 2px solid green;
    }
</style>